/** The dealer rail's two deliberately different data scopes. */
export type DealerScope = "zero_dte" | "all_expiry";

/** R866⑤: delivery is the default; the pooled daily map is an explicit alternate view. */
export const DEFAULT_DEALER_SCOPE: DealerScope = "zero_dte";

export function dealerScopePath(scope: DealerScope): string {
  return scope === "zero_dte"
    ? "/api/dealer/levels"
    : "/api/dealer/gex?root=SPX";
}

export function dealerScopeLabel(scope: DealerScope): string {
  return scope === "zero_dte" ? "0DTE" : "ALL EXPIRY";
}

/**
 * `/api/dealer/levels` preserves the vendor's gamma-OI field names. The existing rail math needs
 * the same four numeric operands under its established boundary shape; this adapter changes no
 * units and declares no aggregate, it only makes the already-served per-strike values drawable.
 */
export function zeroDteGammaOiForDealer(rows: readonly {
  strike: number;
  call_gamma_oi: number;
  put_gamma_oi: number;
}[]): Array<{ strike: number; call: number; put: number; net: number }> {
  return rows.map((row, index) => {
    for (const [field, value] of Object.entries({
      strike: row.strike,
      call_gamma_oi: row.call_gamma_oi,
      put_gamma_oi: row.put_gamma_oi,
    })) {
      if (!Number.isFinite(value)) {
        throw new TypeError(`0DTE dealer row ${index} has non-finite ${field}`);
      }
    }
    return {
      strike: row.strike,
      call: row.call_gamma_oi,
      put: row.put_gamma_oi,
      net: row.call_gamma_oi + row.put_gamma_oi,
    };
  });
}
